var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-6" },
      [
        _c("csp-form-group-radio", {
          attrs: {
            form: _vm.adversaryForm,
            options: _vm.genderOptions,
            property: "gender",
            required: "",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.isGenderPerson
      ? _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("csp-form-group-input", {
              attrs: {
                form: _vm.adversaryForm,
                property: "companyName",
                required: _vm.isGenderCompany,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("csp-form-group-input", {
          attrs: {
            form: _vm.adversaryForm,
            "label-property": _vm.isGenderCompany ? "companyFistName" : "",
            property: "firstName",
            required: _vm.isNameRequired,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("csp-form-group-input", {
          attrs: {
            form: _vm.adversaryForm,
            "label-property": _vm.isGenderCompany ? "companyLastName" : "",
            property: "lastName",
            required: _vm.isNameRequired,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("csp-form-group-input", {
          attrs: { form: _vm.adversaryForm, property: "cargo", required: "" },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "w-100" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("csp-form-group-select-insurance-policy-parent", {
          attrs: {
            "insurance-policy-form":
              _vm.adversaryForm.getSubform("insurancePolicy"),
            property: "parentInsuranceId",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("csp-form-group-input", {
          attrs: {
            form: _vm.adversaryForm,
            property: "adversaryInsuranceReference",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.showMinimalRecordCheckbox &&
    _vm.recordForm.isMinimalRecordCreationAllowed()
      ? _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("csp-form-group-checkbox", {
              attrs: {
                form: _vm.recordForm,
                "label-property": "inputNotRequired",
                property: "minimalRecordCreation",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }